<template>
	<div class="breakcrum-wrapper">
		<template v-for="(item, index) of items">
			<div
				:key="index"
				class="item"
				:class="{ 'is-active': item.active }"
			>
				<div class="icon-wrapper" v-html="item.svg"></div>
				<div class="text">
					{{ item.text }}
				</div>
			</div>
			<div
				v-if="index < items.length - 1"
				:key="index + '' + 'divider'"
				class="divider"
			></div>
		</template>
	</div>
</template>

<script>
export default {
	name: "LayoutSelection",
	components: {},
	props: {
		items: {
			type: Array,
			required: true,
			default: () => [],
		},
	},
	data: () => ({}),
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.breakcrum-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 60%;

	@include custom-min(768px) {
		width: 20%;
	}

	.item {
		flex-shrink: 0;
		padding: 5px;
		background-color: color(background-light-purple-1);
		border-radius: 50%;

		@include custom-min(768px) {
			padding: 0.3919rem;
		}

		&.is-active {
			display: flex;
			align-items: center;
			border-radius: 77.5569px;
			padding-left: 0.5rem;
			padding-right: 0.6875rem;

			@include custom-min(768px) {
				padding-left: 0.625rem;
				padding-right: 1rem;
			}

			.text {
				display: block;
				font-size: 0.8203rem;
				line-height: 140%;
				text-align: center;
				letter-spacing: 0.01em;

				@include custom-min(768px) {
					font-size: 1.0781rem;
				}
			}

			.icon-wrapper {
				margin-right: 0.5rem;

				@include custom-min(768px) {
					padding-right: 0.625rem;
				}
			}
		}
		.text {
			display: none;
		}

		.icon-wrapper {
			border-radius: 50%;
			height: 1.625rem;
			width: 1.625rem;

			display: flex;
			align-items: center;
			justify-content: center;

			@include custom-min(768px) {
				height: 2.0906rem;
				width: 2.0906rem;
			}

			svg {
				height: 100%;
				width: 100%;
				display: block;
			}
		}
	}

	.divider {
		background-color: color(background-light-gray-5);
		flex-grow: 1;
		height: 2px;
		width: 100%;
	}
}
</style>
